import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  y?: number;
};
export function Reveal({
  children,
  delay = 0,
  className,
  y = 24
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.9,
    delay,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-209" data-mp="3bie7zufj95r8">
      {children}
    </motion.div>;
}